export default __webpack_public_path__ + "static/media/refer_friend_sht.449337a4.png";